import React from 'react';
import { CurationHeroHeaderProps, CurationHeroHeaderRootProps } from './CurationHeroHeader.types';
import { Billboard, BillboardSkeleton } from './components/Billboard/Billboard';
import { CurationList, CurationListSkeleton } from './components/CurationList/CurationList';
import { useCurationHeroHeaderData } from './hooks/useCurationHeroHeaderData';
import { useCurationHeroHeaderController } from './CurationHeroHeader.controller';
import { StyledBillboardSafeContainer, StyledContainer, styles } from './CurationHeroHeader.styles';
import { SkeletonGroup } from '@shared/components/Skeleton';
import HeroBackground from './components/HeroBackground/HeroBackground';
import { BoxProps } from '@withjoy/joykit';

const Container: React.FC<BoxProps> = ({ children, ...restProps }) => {
  return (
    <StyledContainer {...restProps} __css={styles.container}>
      {children}
    </StyledContainer>
  );
};

const CurationHeroHeaderRoot = (props: CurationHeroHeaderRootProps) => {
  const { curations } = props;

  const {
    selectedCurationId,
    selectedCuration,
    isMobile,
    billboardRef,
    curationListRef,
    iframeRef,
    handleOnCloseVideoDialog,
    handleOnCurationClick,
    handleOnCurationListArrowClick,
    handleOnViewCurationClick,
    handleOnOpenVideoPlayer
  } = useCurationHeroHeaderController(props);

  return (
    <Container>
      <StyledBillboardSafeContainer __css={styles.billboardSafeContainer}>
        {selectedCuration && (
          <Billboard
            ref={billboardRef}
            curation={selectedCuration}
            handleOnViewCurationClick={handleOnViewCurationClick}
            onOpenVideoPlayer={handleOnOpenVideoPlayer}
            onCloseVideoPlayer={handleOnCloseVideoDialog}
          />
        )}
        <CurationList
          ref={curationListRef}
          curations={curations}
          activeCurationId={selectedCurationId}
          isMobile={isMobile}
          onArrowClick={handleOnCurationListArrowClick}
          onCurationClick={handleOnCurationClick}
        />
      </StyledBillboardSafeContainer>
      {selectedCuration && <HeroBackground curationHeader={selectedCuration.header} ref={iframeRef} />}
    </Container>
  );
};

const CurationHeroHeader: React.FC<CurationHeroHeaderProps> = props => {
  const { eventId, showSkeleton: showSkeletonProp, ...restProps } = props;
  const { curations, loading } = useCurationHeroHeaderData({ eventId });

  return (
    <SkeletonGroup
      isReady={!loading && !showSkeletonProp}
      marginBottom={{ xxs: '40px', md: '64px' }}
      placeholder={
        <Container backgroundColor="mono1">
          <BillboardSkeleton />
          <CurationListSkeleton />
        </Container>
      }
      {...restProps}
    >
      {curations.length === 0 && !loading ? null : <CurationHeroHeaderRoot curations={curations} />}
    </SkeletonGroup>
  );
};

export { CurationHeroHeader };
